jQuery(function ($) {
    $(document).ready(function() {
        $("#woo_delivery_date_field, #woo_delivery_time_field").on("change", function() {
            $(document.body).trigger("update_checkout");
        });
    });
});